<ws-modal-wrapper headerLabel="Parcel Links"
                  acceptLabel="OK"
                  [excludeModalStyling]="true"
                  [disableSave]="!rowsSelected"
                  (save)="save()"
                  (cancel)="cancel()">
    <div class="ws-flex-container-vertical ws-flex-auto ws-stretch">
        <ws-ag-grid-angular [gridOptions]="gridOptions"
                            (gridReady)="onAgGridReady($event)">
        </ws-ag-grid-angular>
    </div>
</ws-modal-wrapper>
